// Persistent chrome around every screen except idle / out-of-service:
// brand logo (left), buying-flow step indicator (center), language toggle +
// optional Cancel (right). Screen content goes in .app-body — screens that
// need a pinned bottom bar render it as a sibling of .screen inside the
// children.

import type { ReactNode } from "react";
import { useLang } from "../i18n/LangContext";
import { BrandMark } from "./BrandMark";
import { Button } from "./Button";
import { LanguageToggle } from "./LanguageToggle";
import { StepIndicator } from "./StepIndicator";

export function KioskShell({
  step,
  onCancel,
  children,
}: {
  step?: number | null;
  onCancel?: () => void;
  children: ReactNode;
}) {
  const { t } = useLang();
  return (
    <div className="app-shell">
      <header className="app-header">
        <BrandMark />
        <div className="app-header__center">
          {step ? <StepIndicator current={step} /> : null}
        </div>
        <div className="app-header__right">
          <LanguageToggle />
          {onCancel ? (
            <Button onClick={onCancel} variant="ghost">
              {t("cancel")}
            </Button>
          ) : null}
        </div>
      </header>
      <div className="app-body">{children}</div>
    </div>
  );
}
